;(function() {
  'use strict'

  angular.module('app.survey-edit', [])
})()
